import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudCategory = () => import('./staff/crudCategory')
const ViewStaffCrudServices = () => import('./staff/crudServices')
const ViewStaffCrudServicesCustomers = () => import('./staff/crudServicesCustomers')
const ViewStaffDisplayServicesCustomers = () => import('./staff/displayServicesCustomers')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ServicesStaffDashboard',
  crudServices: 'ServicesStaffCrudServices',
  crudCategory: 'ServicesStaffCrudCategory',
  crudServicesCustomers: 'ServicesStaffCrudServicesCustomers',
  displayServicesCustomers: 'ServicesStaffDisplayServicesCustomers',
}

const router =
  [
    {
      path: '/st/services',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Servicios',
          }                                 
        },        
        {
          path: 'services',
          name: VIEWS.crudServices,
          component: ViewStaffCrudServices,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM de servicios',
          }                            
        },   
        {
          path: 'services-category',
          name: VIEWS.crudCategory,
          component: ViewStaffCrudCategory,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM de categorias de servicios',
          }                            
        },   
        {
          path: 'services-customers',
          name: VIEWS.crudServicesCustomers,
          component: ViewStaffCrudServicesCustomers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Servicios de clientes',
          }                            
        },    
        {
          path: 'display-services-customers',
          name: VIEWS.displayServicesCustomers,
          component: ViewStaffDisplayServicesCustomers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Monitor de servicios',
          }                            
        }                       
      ]
    },

    {
      path: '/cu/services',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/services',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
